import React, { useState } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import Breadcrumbs from "../../../Common/Breadcrumbs";
import AuditLogsFilters from "../../../components/accessManagement/molecules/AuditLogsFilters";
import AuditLogsTable from "../../../components/accessManagement/organisms/AuditLogsTable";
import "../AccessManagement.css";
import "../Users/Users.css";
import { useDebounce } from "../../../hooks/useDebounce";

const AccessManagementAuditLogsPage: React.FC = () => {
  const [totalCount, setTotalCount] = useState(0);
  const [action, setAction] = useState("");
  const [permissionCode, setPermissionCode] = useState("");
  const [actorSearch, setActorSearch] = useState("");
  const debouncedActorSearch = useDebounce(actorSearch, 600);
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);
  const [startDate, endDate] = dateRange;

  const formatStartOfDayUtc = (date: Date | null): string | undefined => {
    if (!date) return undefined;
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    const utcDate = new Date(Date.UTC(year, month, day, 0, 0, 0, 0));
    return utcDate.toISOString();
  };

  const formatEndOfDayUtc = (date: Date | null): string | undefined => {
    if (!date) return undefined;
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    // Inclusive end of day: 23:59:59.999Z for the selected local date
    const utcDate = new Date(Date.UTC(year, month, day, 23, 59, 59, 999));
    return utcDate.toISOString();
  };

  const from = formatStartOfDayUtc(startDate);
  const to = formatEndOfDayUtc(endDate);

  const handleClearFilters = () => {
    setAction("");
    setPermissionCode("");
    setActorSearch("");
    setDateRange([null, null]);
  };

  return (
    <div className="page-content">
      <Container fluid className="feature-management-page">
        {/* Breadcrumbs */}
        <div className="mb-3 mt-4" style={{ padding: "0 15px" }}>
          <Breadcrumbs
            items={[
              { label: "Access Management" },
              { label: "Audit Logs", active: true },
            ]}
          />
        </div>

        {/* Row 1: Header + Search */}
        <div className="audit-logs-header-row">
          <Row className="align-items-center justify-content-between g-3">
            <Col xs="12" md="auto">
              <h2 className="mb-0">Audit Logs</h2>
              <p className="text-muted mb-0" style={{ fontSize: 13 }}>
                {totalCount} Log Entries
              </p>
            </Col>
            <Col xs="12" md={3}>
              <Form.Control
                type="search"
                placeholder="Search by actor"
                value={actorSearch}
                onChange={(e) => setActorSearch(e.target.value)}
              />
            </Col>
          </Row>
        </div>

        {/* Row 2: Filter By */}
        <div style={{ padding: "0 15px", marginBottom: "24px" }}>
          <AuditLogsFilters
            actionValue={action}
            onActionChange={setAction}
            permissionValue={permissionCode}
            onPermissionChange={setPermissionCode}
            startDate={startDate}
            endDate={endDate}
            onDateRangeChange={setDateRange}
            onClearFilters={handleClearFilters}
          />
        </div>

        {/* Audit logs table */}
        <div style={{ padding: "0 15px" }}>
          <AuditLogsTable
            onTotalChange={setTotalCount}
            action={action}
            permissionCode={permissionCode}
            actor={debouncedActorSearch}
            from={from}
            to={to}
          />
        </div>
      </Container>
    </div>
  );
};

export default AccessManagementAuditLogsPage;
